import MstCodeService from "@/services/nwapp/mstCode.service";

export const mstCodeApi = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    get({ commit }, codeType) {
      return MstCodeService.get(codeType).then(
        (resp) => {
          commit("dummy", "MstCodeService.get - success");
          return Promise.resolve(resp);
        },
        (error) => {
          commit("dummy", "MstCodeService.get - error");
          return Promise.reject(error.response);
        }
      );
    },
  },
  mutations: {
    dummy(state, obj) {
      console.log(obj);
    },
  },
};
